import React, { useState, useEffect } from 'react';
import { tourApi } from '../api/client';

function TourForm() {
  const [tours, setTours] = useState([]);
  const [formData, setFormData] = useState({
    type: '',
    name_nl: '',
  });
  const [message, setMessage] = useState('');

  useEffect(() => {
    fetchTours();
  }, []);

  const fetchTours = async () => {
    try {
      const response = await tourApi.list();
      setTours(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to fetch tours' });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await tourApi.create(formData);
      setMessage({ type: 'success', text: 'Tour created successfully' });
      setFormData({ type: '', name_nl: '' });
      fetchTours();
    } catch (error) {
      setMessage({ type: 'error', text: 'Failed to create tour' });
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure?')) {
      try {
        await tourApi.delete(id);
        setMessage({ type: 'success', text: 'Tour deleted' });
        fetchTours();
      } catch (error) {
        setMessage({ type: 'error', text: 'Failed to delete tour' });
      }
    }
  };

  return (
    <div>
      <h2>Manage Tours</h2>

      {message && (
        <div className={`message ${message.type}`}>{message.text}</div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Tour Type</label>
          <input
            type="text"
            name="type"
            value={formData.type}
            onChange={handleChange}
            placeholder="e.g., Rail Tour, Multi-leg Journey"
            required
          />
        </div>

        <div className="form-group">
          <label>Tour Name (NL)</label>
          <input
            type="text"
            name="name_nl"
            value={formData.name_nl}
            onChange={handleChange}
            placeholder="e.g., Brussels to Vienna"
            required
          />
        </div>


        <button type="submit">Create Tour</button>
      </form>

      <h3>Existing Tours</h3>
      {tours.length === 0 ? (
        <p>No tours yet</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Type</th>
              <th>Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tours.map((tour) => (
              <tr key={tour.id}>
                <td>{tour.id}</td>
                <td>{tour.type}</td>
                <td>{tour.name_nl}</td>
                <td>
                  <button
                    className="btn-delete"
                    onClick={() => handleDelete(tour.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export default TourForm;
